<template>
  <div class="seth-set bg-primary">
    <div
      class="absolute top-0 w-full justify-between items-center ban-marcom100 px-6 flex"
    >
      <div>
        <p
          @click="handleback('whatsapp-bot')"
          class="gap-2 cursor-pointer fsize14 text-white flex items-center"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
          />
          Go Back
        </p>
      </div>
      <!-- <div class="flex gap-4 items-center">
        <feather-icon icon="BellIcon" class="text-white" />
        <vs-button
          color="white"
          class="bg-white text-primary w-full"
          @click="handleback('pick-template')"
          >Select Template</vs-button
        >
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async handleback(name) {
      await this.$router.push({ name: name });
      window.location.reload();
    },
  },
};
</script>
